module.exports = __webpack_public_path__ + "img/skill-centre.36b1433d.png";